import React, { useState, useEffect } from "react";
import axios from "axios";
// import { API_BASE_URL } from '../../utils/config';
import { Button, Modal } from "react-bootstrap";
import blueLike from "../../Img/blueLike.png";
import { API_BASE_URL } from "../../utils/config";
const AllPostsLike = ({ postId }) => {
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [likes, setLikes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  let bearerToken = localStorage.getItem("jwt_token");
  let config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    // Check if the user has liked this post previously
    const likedPosts = JSON.parse(localStorage.getItem("likedPosts")) || [];
    if (likedPosts.includes(postId)) {
      setLiked(true);
    }

    // Fetch the number of likes for this post
    axios
      .get(`${API_BASE_URL}/wp-json/custom-like/v1/likes/?id=${postId}`, config)
      .then((response) => {
        console.log("line28=", response);
        setLikesCount(response.data.count);
        setLikes(response.data.likes);
      })
      .catch((error) => {
        console.error("Error fetching likes:", error);
      });
  }, []);

  const handleLike = () => {
    // Add the post to the list of liked posts in localStorage
    let likedPosts = JSON.parse(localStorage.getItem("likedPosts")) || [];
    if (!liked) {
      likedPosts.push(postId);
    } else {
      likedPosts = likedPosts.filter((id) => id !== postId);
    }
    localStorage.setItem("likedPosts", JSON.stringify(likedPosts));

    // Update the like status and count
    setLiked(!liked);
    console.log(`liked=${liked} likecount= ${likesCount}`);
    setLikesCount(liked ? parseInt(likesCount) - 1 : parseInt(likesCount) + 1);
    const postData = {
      id: postId,
      action: liked,
    };

    // Update the server with the like status
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom-like/v1/like/?id=${postId}`,
        postData,
        config
      )
      .then((response) => {
        if (response.data.msg === "Liked") {
          // Update the list of likes (assuming the server returns updated list)
          // setLikes(response.data.likes);
        }
      })
      .catch((error) => {
        console.error("Error liking post:", error);
      });
  };

  const handleModal = () => {
    setShowModal(!showModal);
    axios
      .get(`${API_BASE_URL}/wp-json/custom-like/v1/likes/?id=${postId}`, config)
      .then((response) => {
        console.log("line28=", response);
        setLikesCount(response.data.count);
        setLikes(response.data.likes);
        setShow(true);
      })
      .catch((error) => {
        console.error("Error fetching likes:", error);
      });
  };
  const handleClose = () => {
    setShow(false);
  };
  let likedText = "";
  if (liked && likesCount == 1) {
    likedText = `${likesCount}`;
  } else if (liked && likesCount > 1) {
    likedText = `you and ${likesCount - 1}  others`;
  } else if (!liked && likesCount >= 1) {
    likedText = `${likesCount}`;
  } else {
    likedText = ``;
  }
  return (
    <div>
      <div className="pb-2 d-flex align-items-center ">
        <button className="bg-white border-0 mb-1">
          <img src={blueLike} alt="like" width={25} />
        </button>
        <span className="likeCountPara2 fw-bold">
          {likesCount}
          {/* {liked && likesCount > 1 ? `you and other${likesCount - 1} people likes this` : `${likesCount} people likes this`} {liked && likesCount == 1 ? `you  likes this` : ``} {!liked && likesCount == 0 ? `0 people you  likes this` : ``} */}
          {/* {likesCount}
                    {likesCount === 1 ? ' people like this' : ' people like this'} */}
        </span>
      </div>
      {/* <button onClick={handleModal}>View Likes</button> */}

      {/*  */}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 pb-1" closeButton>
          {/* <Modal.Title>Liked Users</Modal.Title> */}
          <div className="">
            <span
              style={{ borderBottom: "3px solid red" }}
              className="fs-5 fw-bold"
            >
              ❤️{likesCount}
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          {likes?.map((like, index) => (
            <div className="fs-5 " key={index}>
              {like}
            </div>
          ))}
        </Modal.Body>
      </Modal>

      {/*  */}
    </div>
  );
};

export default AllPostsLike;
